import React from 'react';

export default function Wrapper(props) {
    var size = {
        small: '808px',
        medium: '954px',
        large: '1100px'
    };

    return (
        <div className={(props.className || '') + " px-5 mx-auto"} style={{maxWidth: size[(props.size || 'large')]}}>
            {props.children}
        </div>
    );
}